<div class="app-loader" *ngIf="show">
    <img class="image" src="assets/img/KlearAi-loading.gif" alt="Loader"/>
</div>